import { render, staticRenderFns } from "./NonRxBanner.vue?vue&type=template&id=b95aa076"
import script from "./NonRxBanner.vue?vue&type=script&lang=js"
export * from "./NonRxBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports